const R = {
  EPCS_ORDER_SIGNING: "epcs-order-signing",
  CLINICAL_APP_LOGIN: "clinical-app-login",
  SUPERVISED_ASSURANCE: "supervised-assurance",
  ENROLL_LOGIN: "enroll-login",
  DESKTOP_ACCESS: "endpoint-login",
  IDP_AUTHN: "idp-authn"
}, A = {
  ENDPOINT: "endpoint",
  AUTHN_WEB_UI: "authn-web-ui"
};
var r = /* @__PURE__ */ ((a) => (a.FACTOR_DATA_READY = "factor-data-ready", a.FACTOR_CHANGED = "factor-changed", a.ERROR = "error", a.CLOSE_WINDOW = "close-window", a.APP_AUTHENTICATION_STATUS = "app-authentication-status", a.APP_AUTHENTICATION_CANCELED = "app-authentication-canceled", a))(r || {}), i = /* @__PURE__ */ ((a) => (a.FACE_ID = "face", a.PROX = "prox", a.PASSWORD = "pwd", a.IMPR_ID = "impr-id", a.IMPR_PIN = "impr-pin", a.IID_DISABLED = "impr-id-push-disabled", a))(i || {}), o = /* @__PURE__ */ ((a) => (a.KNOW = "know", a.HAVE = "have", a.ARE = "are", a))(o || {}), I = /* @__PURE__ */ ((a) => (a.ACCEPTED = "accepted", a.NOT_AVAILABLE = "not-available", a.PUSH_TIMEOUT = "push-timeout", a.REJECTED = "rejected", a))(I || {});
const s = {
  face: {
    factorType: "face",
    factorCategory: "are",
    pushable: !1
  },
  prox: {
    factorType: "prox",
    factorCategory: "have",
    pushable: !1
  },
  pwd: {
    factorType: "pwd",
    factorCategory: "know",
    pushable: !1
  },
  "impr-id": {
    factorType: "impr-id",
    factorCategory: "have",
    pushable: !0
  },
  "impr-pin": {
    factorType: "impr-pin",
    factorCategory: "have",
    pushable: !1
  }
};
var N = /* @__PURE__ */ ((a) => (a.AUTHENTICATED = "authenticated", a.SUCCESS = "success", a.FAILURE = "failure", a.ENROLLED = "enrolled", a.FACTORS = "factors", a.SESSION = "session", a.READY = "ready", a.NOT_READY = "not-ready", a.CANCEL = "cancel", a.TERMINATE_SESSION = "terminate-session", a.ERROR = "error", a.NOT_AVAILABLE = "not-available", a.IMPR_ID_ERROR = "iid-error", a.INITIALIZED = "initialized", a.OFFLINE = "offline", a.ONLINE = "online", a.NOT_ENROLLED = "not-enrolled", a.TIMEOUT = "timeout", a.NO_SESSION = "no-session", a.SESSION_FAILED = "session-failed", a.INTERNAL_RESTART = "internal-restart", a.INTERNAL_ERROR = "internal-error", a.START_ENROLLING = "start_enrolling", a.RESTART_STATE = "restart-state", a.START_AUTHENTICATING = "start_authenticating", a))(N || {});
export {
  r as AgentEvent,
  i as AuthnMethod,
  R as ContextType,
  N as EventType,
  s as FACTORS,
  o as FactorCategory,
  I as PushStatus,
  A as ResourceType
};
//# sourceMappingURL=types.js.map
